import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';
import { PulseSyncMode } from '@/enums/PulseSyncMode';
import { PosSync } from '@/interfaces/models/PosSync';
import { Pagination } from '@/interfaces/api/Pagination';
import { Page } from '@/interfaces/api/Page';
import Filter from '@/interfaces/api/Filter';

export default class PulsePosApiService extends ApiService<any> {
  constructor() {
    super('pulse');
  }

  public syncMenu(payload: { venue: string; mode: PulseSyncMode }): AxiosPromise<{ syncJobId: string }> {
    return axios.post(`${this.getBaseUrl()}/menu/sync`, {
      mode: payload.mode,
      venue: payload.venue,
    });
  }

  public getPosSyncs(page: Page, filter: Filter): AxiosPromise<PosSync[] | Pagination<PosSync>> {
    return axios.get(`${this.getBaseUrl()}/menu/sync-jobs`, { params: { page, ...filter } });
  }
}
